import { apiUrl } from '$lib/settings/api';

/** @type {import('./$types').PageLoad} */
export async function load({ params }) {
	const url = apiUrl + 'programs/programs/index?limit=30';
	const res = await fetch(url);
	const apiResponse = await res.json();
	const programs = apiResponse['data']['documents'];

	return {
		programs: programs
	};
}
